

const getHeader = (method, isdefault = true) => {

    if (method != 'POST') return {}

    let header = {}

    if (isdefault) {
        header['Content-Type'] = 'application/json'
        header['Accept'] = 'application/json'
    } else if (isdefault == 'formdata'){
        headers['Content-Type'] = 'multipart/form-data';
    }

    let x_access_token = localStorage.getItem('x-access-token')

    if (x_access_token == undefined || x_access_token == "") return false

    header['x-access-token'] = x_access_token


    return header

}

export default { getHeader };